import type { CustomerProfile } from '../../types'

export type AddressBookEntry = {
  id: string
  label: string
  firstName: string
  lastName: string
  addressLine: string
  city: string
  postalCode: string
  province: string
  country: string
  phone: string
  useShipping: boolean
  useBilling: boolean
  defaultShipping: boolean
  defaultBilling: boolean
}

export type AddressEditorState = {
  label: string
  firstName: string
  lastName: string
  addressLine: string
  city: string
  postalCode: string
  province: string
  country: string
  phone: string
  useShipping: boolean
  useBilling: boolean
  setDefault: boolean
}

export type AddressSeedProfile = Pick<
  CustomerProfile,
  'firstName' | 'lastName' | 'phone' | 'residentialAddress' | 'billingAddress' | 'shippingAddress'
>

export const emptyEditorState = (profile: CustomerProfile): AddressEditorState => ({
  label: '',
  firstName: profile.firstName || '',
  lastName: profile.lastName || '',
  addressLine: '',
  city: '',
  postalCode: '',
  province: '',
  country: 'IT',
  phone: profile.phone || '',
  useShipping: true,
  useBilling: false,
  setDefault: false,
})
